// AUTO-GENERATED SQL Builder (V40 Final) for ChecklistItem
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class ChecklistItemSql {
  private ast = new SqlAst('ChecklistItem', 'checklistItem');
  public readonly main: any = {};

  public guid: SqlField;
  public checklistSectionId: SqlField;
  public weddingCardId: SqlField;
  public title: SqlField;
  public categoryLabel: SqlField;
  public viaServiceCategoryId: SqlField;
  public isAutoComplete: SqlField;
  public isDone: SqlField;
  public sortOrder: SqlField;
  public checklistSection: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public viaServiceCategory: SqlNavHybrid;
  public weddingCard: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('checklistItem', 'guid', '', 'id', 'checklistItem_guid');
    this.checklistSectionId = new SqlField('checklistItem', 'checklistSectionId', 'checklistSection', 'id', 'checklistItem_checklistSection');
    this.weddingCardId = new SqlField('checklistItem', 'weddingCardId', 'weddingCard', 'id', 'checklistItem_weddingCard');
    this.title = new SqlField('checklistItem', 'title', '', 'id', 'checklistItem_title');
    this.categoryLabel = new SqlField('checklistItem', 'categoryLabel', '', 'id', 'checklistItem_categoryLabel');
    this.viaServiceCategoryId = new SqlField('checklistItem', 'viaServiceCategoryId', '', 'id', 'checklistItem_viaServiceCategory');
    this.isAutoComplete = new SqlField('checklistItem', 'isAutoComplete', '', 'id', 'checklistItem_isAutoComplete');
    this.isDone = new SqlField('checklistItem', 'isDone', '', 'id', 'checklistItem_isDone');
    this.sortOrder = new SqlField('checklistItem', 'sortOrder', '', 'id', 'checklistItem_sortOrder');
    this.checklistSection = createNavHybrid('checklistItem', 'checklistItem_checklistSection', 'ChecklistSection');
    this.createdByUser = createNavHybrid('checklistItem', 'checklistItem_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('checklistItem', 'checklistItem_updatedByUser', 'User');
    this.viaServiceCategory = createNavHybrid('checklistItem', 'checklistItem_viaServiceCategory', 'ServiceCategory');
    this.weddingCard = createNavHybrid('checklistItem', 'checklistItem_weddingCard', 'WeddingCard');
    this.id = new SqlField('checklistItem', 'id', '', 'id', 'checklistItem_id');
    this.isDeleted = new SqlField('checklistItem', 'isDeleted', '', 'id', 'checklistItem_isDeleted');
    this.createdBy = new SqlField('checklistItem', 'createdBy', '', 'id', 'checklistItem_createdBy');
    this.createdDate = new SqlField('checklistItem', 'createdDate', '', 'id', 'checklistItem_createdDate');
    this.updatedBy = new SqlField('checklistItem', 'updatedBy', '', 'id', 'checklistItem_updatedBy');
    this.updatedDate = new SqlField('checklistItem', 'updatedDate', '', 'id', 'checklistItem_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:ChecklistItemSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:ChecklistItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:ChecklistItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:ChecklistItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:ChecklistItemSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:ChecklistItemSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:ChecklistItemSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:ChecklistItemSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:ChecklistItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:ChecklistItemSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
